import React from "react";
import {MdCheckCircle, MdCancel} from 'react-icons/md';

function Document({href, name}) {
  return (
    <div className="py-2 px-3 mb-1 bg-white fs-10 weight-500">
      <a href={href} className="color-black text-decoration-none" target="blank">
        {
          href 
            ? <MdCheckCircle className="me-1"/>
            : <MdCancel className="me-1" />
        }
        {name}
      </a>
    </div>
  )
}

export default Document;
